<app-navigation-header title="Add Client" i18n-title="@@addClientMainTab-addClientTitle" svgName="sl-add">
	<div [appBreadcrumbLabel]="addClientBreadcrumbLabel" class="add-client-container">
		<!-- Stepper header container for steps -->
		<div class="horizontal-stepper-label-container">
			<span>
				<app-access-horizontal-stepper-labels [steps]="steps" [currentStep]="currentStep">
				</app-access-horizontal-stepper-labels>
			</span>
			<span class="mat-stepper-navigator">
				<!-- Back button: Show on step 1 (property setup) only, hidden on step 0, step 2, and when property is preselected (step 1 = confirmation) -->
				@if (currentStep !== 0 && currentStep !== 2 && !(currentStep === 1 && preselectedLocationId)) {
					<button
						class="secondary-small-button"
						(click)="onPressBack()"
						i18n="@@addClientMainTab-backButton"
						data-automation-id="add-client-back-button"
					>
						Back
					</button>
				}

				<!-- Continue/Confirm button: Hidden on final step (step 2) and when property is preselected at step 1 (confirmation screen has its own buttons) -->
				<!-- Button text: "Confirm" when (1) property is preselected on step 0, or (2) user has confirmed property selection on step 1. Otherwise "Continue" -->
				@if (currentStep !== 2 && !(currentStep === 1 && preselectedLocationId)) {
					<button
						(click)="onPressContinue()"
						class="right-button primary-small-button"
						data-automation-id="add-client-continue-button"
						[disabled]="!enableContinueButton"
					>
						@if (
							(currentStep === 0 && preselectedLocationId) ||
							(currentStep === 1 && addClientPropertySetup?.hasConfirmedSelection)
						) {
							<span i18n="@@addClientMainTab-confirmButton">Confirm</span>
						} @else {
							<span i18n="@@addClientMainTab-continueButton">Continue</span>
						}
					</button>
				}
			</span>
		</div>

		@if (currentStep === 0) {
			<div>
				<app-add-client-details [editClient]="editClient" [selectedProperty]="selectedProperty">
				</app-add-client-details>
			</div>
		}

		<!-- If property is preselected, step 1 is confirmation; otherwise it's property setup -->
		@if (currentStep === 1 && !preselectedLocationId) {
			<div>
				<app-add-client-property-setup
					[editClient]="editClient"
					[propertySelectionType]="propertySelectionType"
					(propertySelectionTypeChange)="onPropertySelectionTypeChanged($event)"
					(propertySelected)="onPropertySelected($event)"
				>
				</app-add-client-property-setup>
			</div>
		}
		@if (currentStep === 1 && preselectedLocationId) {
			<div>
				<app-add-client-confirmation
					[editClient]="editClient"
					[selectedProperty]="selectedProperty"
					[isPropertyPreselected]="!!preselectedLocationId"
					(returnToClients)="onReturnToClients()"
					(addAnotherClient)="onAddAnotherClient()"
				>
				</app-add-client-confirmation>
			</div>
		}

		@if (currentStep === 2) {
			<div>
				<app-add-client-confirmation
					[editClient]="editClient"
					[selectedProperty]="selectedProperty"
					[isPropertyPreselected]="!!preselectedLocationId"
					(returnToClients)="onReturnToClients()"
					(addAnotherClient)="onAddAnotherClient()"
				>
				</app-add-client-confirmation>
			</div>
		}
	</div>
</app-navigation-header>
